import { useEffect, useState, useContext } from "react";
import { BASELINE } from "../../../util";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserContext";
import { toast } from "react-hot-toast";
import { AiOutlineCheck, AiOutlineInfoCircle } from 'react-icons/ai';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import InfoIconWithTooltip from '../InfoIconWithTooltip';
import MockSATSection from "./mocksatsection";
import { motion } from 'framer-motion';

const SAT_SECTION_CONFIG = {
  1: {
    tag: 'eng', uiTag: 'English', module: 'Module 1',
    totalQ: 27, timeMin: 32,
    diffDist: { E: 0.26, M: 0.48, H: 0.26 },
    domains: [
      { subtopics: ['Words in Context', 'Text Structure and Purpose', 'Cross-Text Connections'], count: 7 },
      { subtopics: ['Inferences', 'Central Ideas and Details', 'Command of Evidence'], count: 7 },
      { subtopics: ['Rhetorical Synthesis', 'Transitions'], count: 6 },
      { subtopics: ['Boundaries', 'Form, Structure, and Sense'], count: 7 },
    ],
  },
  2: {
    tag: 'eng', uiTag: 'English', module: 'Module 2',
    totalQ: 27, timeMin: 32,
    diffDist: { E: 0.15, M: 0.45, H: 0.40 },
    domains: [
      { subtopics: ['Words in Context', 'Text Structure and Purpose', 'Cross-Text Connections'], count: 7 },
      { subtopics: ['Inferences', 'Central Ideas and Details', 'Command of Evidence'], count: 7 },
      { subtopics: ['Rhetorical Synthesis', 'Transitions'], count: 6 },
      { subtopics: ['Boundaries', 'Form, Structure, and Sense'], count: 7 },
    ],
  },
  3: {
    tag: 'math', uiTag: 'Math', module: 'Module 1',
    totalQ: 22, timeMin: 35,
    diffDist: { E: 0.32, M: 0.41, H: 0.27 },
    domains: [
      { subtopics: ['Linear functions', 'Systems of two linear equations in two variables', 'Linear inequalities in one or two variables', 'Linear equations in one variable', 'Linear equations in two variables'], count: 8 },
      { subtopics: ['Nonlinear functions', 'Equivalent expressions', 'Nonlinear equations in one variable and systems of equations in two variables'], count: 7 },
      { subtopics: ['Ratios, rates, proportional relationships, and units', 'Inference from sample statistics and margin of error', 'Probability and conditional probability', 'Percentages', 'One-variable data: Distributions and measures of center and spread', 'Two-variable data: Models and scatterplots', 'Evaluating statistical claims: Observational studies and experiments'], count: 4 },
      { subtopics: ['Lines, angles, and triangles', 'Right triangles and trigonometry', 'Area and volume', 'Circles'], count: 3 },
    ],
  },
  4: {
    tag: 'math', uiTag: 'Math', module: 'Module 2',
    totalQ: 22, timeMin: 35,
    diffDist: { E: 0.14, M: 0.41, H: 0.45 },
    domains: [
      { subtopics: ['Linear functions', 'Systems of two linear equations in two variables', 'Linear inequalities in one or two variables', 'Linear equations in one variable', 'Linear equations in two variables'], count: 8 },
      { subtopics: ['Nonlinear functions', 'Equivalent expressions', 'Nonlinear equations in one variable and systems of equations in two variables'], count: 7 },
      { subtopics: ['Ratios, rates, proportional relationships, and units', 'Inference from sample statistics and margin of error', 'Probability and conditional probability', 'Percentages', 'One-variable data: Distributions and measures of center and spread', 'Two-variable data: Models and scatterplots', 'Evaluating statistical claims: Observational studies and experiments'], count: 4 },
      { subtopics: ['Lines, angles, and triangles', 'Right triangles and trigonometry', 'Area and volume', 'Circles'], count: 3 },
    ],
  },
};

const RandomSATReady = ({ setLoading }) => {
  const { user, clearLocalStorageExceptUser } = useContext(UserContext);
  const [selectedButton, setSelectedButton] = useState(null);
  const navigate = useNavigate();
  const [isTutorActive, setIsTutorActive] = useState(false);
  const [isTimedActive, setIsTimedActive] = useState(false);
  const [timerMinutes, setTimerMinutes] = useState(45); // Default time set to 45 minutes
  const [isBlitzActive, setIsBlitzActive] = useState(false);
  const [blitzSeconds, setBlitzSeconds] = useState(30);
  const [currentPassages, setCurrentPassages] = useState(0);
  const [min, setmin] = useState(0);

  const [totalq, settotalq] = useState([]);

  const [correct, setcorrect] = useState(0);
  const [incorrect, setincorrect] = useState(0);
  const [marked, setmarked] = useState(0);
  const [omitted, setomitted] = useState(0);

  const [diff, setDiff] = useState({ E: [], M: [], H: [] });
  const [englishCount, setEnglishCount] = useState([]);
  const [mathCount, setMathCount] = useState([]);
  const [activeSegment, setActiveSegment] = useState('English');  // Default to 'All'
  const [displaySubjects, setDisplaySubjects] = useState([]);
  const [total, settotal] = useState(0);
  const [allSATScores, setAllSATScores] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const mockCardData = [1, 2, 3, 4, 5, 6];

  const [pendingMockSat, setPendingMockSat] = useState(null);

  const [activeFilters, setActiveFilters] = useState({
    unused: false,
    incorrect: false,
    marked: false,
    omitted: false,
    correct: false
  });

  const [esubjects, esetSubjects] = useState([
    {
      name: 'Information and Ideas', count: 0, isOpen: true, isSelected: false, tag: 'English',
      subTopics: [
        { name: 'Inferences', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Central Ideas and Details', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Command of Evidence', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Craft and Structure', count: 0, isOpen: true, isSelected: false, tag: 'English',
      subTopics: [
        { name: 'Words in Context', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Text Structure and Purpose', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Cross-Text Connections', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Expression of Ideas', count: 0, isOpen: true, isSelected: false, tag: 'English',
      subTopics: [
        { name: 'Rhetorical Synthesis', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Transitions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } }
      ]
    },
    {
      name: 'Standard English Conventions', count: 0, isOpen: true, isSelected: false, tag: 'English',
      subTopics: [
        { name: 'Boundaries', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Form, Structure, and Sense', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } }
      ]
    }
  ]);

  const [msubjects, msetSubjects] = useState([
    {
      name: 'Algebra', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Linear functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Systems of two linear equations in two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Linear inequalities in one or two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Linear equations in one variable', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Linear equations in two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },

      ]
    },
    {
      name: 'Advanced Math', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Nonlinear functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Equivalent expressions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Nonlinear equations in one variable and systems of equations in two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Problem-solving and Data Analysis', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Ratios, rates, proportional relationships, and units', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Inference from sample statistics and margin of error', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Probability and conditional probability', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Percentages', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'One-variable data: Distributions and measures of center and spread', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Two-variable data: Models and scatterplots', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Evaluating statistical claims: Observational studies and experiments', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Geometry and Trigonometry', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Lines, angles, and triangles', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Right triangles and trigonometry', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Area and volume', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Circles', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    }
  ]);

  useEffect(() => {
    if (user) {
      axios.post(`${BASELINE}testresult/get`, { id: user.u_id })
        .then(response => {
          // SAT 타입의 결과만 필터링
          const satResults = response.data.filter(item => item.type === "SAT");
          let scoresArray = [];
          // 데이터가 최신이 마지막에 오도록 reverse() 사용
          for (let item of satResults.reverse()) {
            if (item.eng_score != null && item.math_score != null) {
              const engScore = Number(item.eng_score);
              const mathScore = Number(item.math_score);
              const total = engScore + mathScore;
              scoresArray.push({
                total,  // 총점 (예: 1600 만점)
                eng: engScore,
                math: mathScore,
                date: item.date,
                test_name: Number(item.test_name[4])
              });
            }
          }
          // 다시 원래 순서대로(오래된 순) 만들기
          const reversedScores = [...scoresArray].reverse();
          setAllSATScores(reversedScores);
        })
        .catch(err => console.error(err));
    }
  }, [user]);

  const getMockScoresForCard = (mockNumber) => {
    for (let i = 0; i < allSATScores.length; i++) {
      // test_name이 문자열일 경우 숫자로 변환 후 비교
      if (allSATScores[i].test_name === mockNumber) {
        return allSATScores[i];
      }
    }
    return null;
  };

  const toggleSubTopic = (subjectType, subjectIndex, subTopicIndex) => {
    const setSubjects = subjectType === 'English' ? esetSubjects : msetSubjects;

    setSubjects(prevSubjects => {
      return prevSubjects.map((subject, i) => {
        if (i === subjectIndex) {
          const updatedSubTopics = subject.subTopics.map((subTopic, stIndex) => {
            if (stIndex === subTopicIndex && subTopic.count !== 0) { // Only toggle if count is not zero
              return {
                ...subTopic,
                isSelected: !subTopic.isSelected
              };
            }
            return subTopic;
          });

          // Determine if any subtopic is selected
          const anySubSelected = updatedSubTopics.some(subTopic => subTopic.isSelected);

          return {
            ...subject,
            subTopics: updatedSubTopics,
            isSelected: anySubSelected // Set main subject's isSelected based on subtopics
          };
        }
        return subject;
      });
    });
  };

  // Function to toggle the open/close state of a subject
  const toggleSubjectOpen = (index) => {
    let subjectsArray = activeSegment === 'English' ? esubjects :
      activeSegment === 'Math' ? msubjects : [...esubjects, ...msubjects];

    if (index >= 0 && index < subjectsArray.length) {
      const newSubjects = subjectsArray.map((subject, i) => {
        if (i === index) {
          return {
            ...subject,
            isOpen: !subject.isOpen // Toggle isOpen
          };
        }
        return subject;
      });

      if (activeSegment === 'English') {
        esetSubjects(newSubjects);
      } else if (activeSegment === 'Math') {
        msetSubjects(newSubjects);
      } else {
        esetSubjects(newSubjects.slice(0, esubjects.length));

        msetSubjects(newSubjects.slice(esubjects.length));
      }
    } else {
      console.error("Subject index out of bounds");
    }
  };

  const toggleSubjectSelect = (index) => {
    let subjectsArray = activeSegment === 'English' ? esubjects :
      activeSegment === 'Math' ? msubjects : [...esubjects, ...msubjects];

    if (index >= 0 && index < subjectsArray.length) {
      const newSubjects = subjectsArray.map((subject, i) => {
        if (i === index) {
          const newIsSelected = !subject.isSelected;
          let updatedSubTopics = subject.subTopics;

          if (newIsSelected) {
            // Select all subtopics that have count > 0
            updatedSubTopics = subject.subTopics.map(subTopic => ({
              ...subTopic,
              isSelected: subTopic.count > 0 ? true : subTopic.isSelected
            }));
          } else {
            // Unselect all subtopics when deselecting
            updatedSubTopics = subject.subTopics.map(subTopic => ({
              ...subTopic,
              isSelected: false
            }));
          }

          return {
            ...subject,
            isSelected: newIsSelected,
            subTopics: updatedSubTopics
          };
        }
        return subject;
      });

      if (activeSegment === 'English') {
        esetSubjects(newSubjects);
      } else if (activeSegment === 'Math') {
        msetSubjects(newSubjects);
      } else {
        esetSubjects(newSubjects.slice(0, esubjects.length));
        msetSubjects(newSubjects.slice(esubjects.length));
      }
    } else {
      console.error("Subject index out of bounds");
    }
  };

  function processAllTestResults(testDataArray) {
    // Define the keys for each type of questionIds array
    const keys = ['Correct_questionIds', 'Incorrect_questionIds', 'Marked_questionIds', 'Omitted_questionIds'];

    // Initialize objects to collect all IDs across all objects
    const allIds = {
      Correct_questionIds: [],
      Incorrect_questionIds: [],
      Marked_questionIds: [],
      Omitted_questionIds: []
    };

    let allQuestionIds = [];

    // Process each test data object in the array
    testDataArray.forEach(testData => {
      keys.forEach(key => {
        // JSON 파싱 후, 내부의 questionIds 배열만 추출
        // [{questionIds: xx, ...}, {questionIds: yy, ...}] 이런 식으로 들어있다고 가정
        const parsed = JSON.parse(testData[key] || '[]');

        // "allQuestionIds"를 전부 모아두는 로직 (중복 제거는 아래에서 따로 처리)
        const questionIdValues = parsed.map(item => item.questionIds);
        allQuestionIds = allQuestionIds.concat(questionIdValues);

        // allIds[key]에 현재 testData에서 가져온 배열을 일단 합쳐둠
        allIds[key] = allIds[key].concat(parsed);
      });
    });

    // ------------------ (추가된 부분) ------------------
    // 1) '중복' 제거: 동일한 questionIds(객체)가 여러 번 들어오면 한 번만 세도록 처리
    keys.forEach(key => {
      // questionIds가 담긴 객체 배열에서, "questionIds" 값이 같은 중복 객체는 제거
      // (JSON.stringify 등을 이용하거나, 별도의 맵을 써도 됩니다.)
      const uniqueMap = new Map();
      allIds[key].forEach(obj => {
        uniqueMap.set(obj.questionIds, obj);
      });
      // 최종적으로 Map의 value들만 가져와서 Array로 변환
      allIds[key] = Array.from(uniqueMap.values());
    });

    // 2) 정답/오답 충돌 처리:
    //    "하나라도 정답으로 맞힌 기록이 있다면" => Incorrect에서 제거
    allIds.Incorrect_questionIds = allIds.Incorrect_questionIds.filter(incObj => {
      // correct 배열(Correct_questionIds)에 동일한 questionIds가 있는지 확인
      const hasCorrectRecord = allIds.Correct_questionIds.some(
        corrObj => corrObj.questionIds === incObj.questionIds
      );
      // 만약 정답으로 기록된 적이 있으면, 해당 문제는 오답에서 제외
      return !hasCorrectRecord;
    });
    // --------------------------------------------------

    // allQuestionIds 에 대해서도 중복 제거
    allQuestionIds = Array.from(new Set(allQuestionIds));

    // setcorrect, setincorrect 등 기존 로직(예시):
    setcorrect(allIds.Correct_questionIds);
    setincorrect(allIds.Incorrect_questionIds);
    setmarked(allIds.Marked_questionIds);
    setomitted(allIds.Omitted_questionIds);

    return {
      allQuestionIds
    };
  }

  function processAllTestResults4teacher(testDataArray) {
    let usedarr = [];

    // 1) quiz_data에서 questions를 가져와 모두 합친 뒤
    testDataArray.forEach(testData => {
      if (testData.quiz_data !== null) {
        const questions = JSON.parse(testData.quiz_data).questions;
        usedarr = usedarr.concat(questions);
      }
    });
    // 2) 중복 제거
    usedarr = [...new Set(usedarr)];

    // 3) 빈 배열이면 API 호출하지 않고 중단
    if (usedarr.length === 0) {
      return { usedarr };
      // 혹은 그냥 `return;`으로 종료해도 됨
    }

    // 4) 배열이 비어 있지 않으면 axios 호출
    axios.get(`${BASELINE}questions/satfortest`, {
      params: { id: usedarr },
    })
      .then((response) => {
        setomitted(response.data);
      })
      .catch((err) => {
        console.error(err);
      });

    return { usedarr };
  }

  async function createtestoptions() {
    if (!user) {
      toast.error("Please login before starting the test");
      navigate("/login"); // Redirect user to the /login page
      return;
    }

    if (user.role === 'student') {
      axios.get(`${BASELINE}tests/byuser/${user.u_id}`)
        .then(response => {
          const results = processAllTestResults(response.data);
          if (results) {
            axios.get(`${BASELINE}getquestionids`)
              .then(response => {
                const existingIds = new Set(results.allQuestionIds);
                const uniqueQuestions = response.data.filter(question => !existingIds.has(question.questionIds));
                settotalq(uniqueQuestions);
              })
              .catch(error => {
                console.error("Error fetching question IDs:", error);
              });
          }
        })
        .catch(error => {
          console.error("Error fetching user tests:", error);
        });
    }
    else if (user.role === 'teacher') {
      axios.get(`${BASELINE}tests/byteacher/${user.u_id}`)
        .then(response => {
          const results = processAllTestResults4teacher(response.data);

          if (results && results.usedarr.length > 0) {
            axios.get(`${BASELINE}getquestionids`)
              .then(response => {
                const existingIds = new Set(results.usedarr);
                const uniqueQuestions = response.data.filter(question => !existingIds.has(question.questionIds));
                settotalq(uniqueQuestions);
              })
              .catch(error => {
                console.error("Error fetching question IDs:", error);
              });
          } else {
            axios.get(`${BASELINE}getquestionids`)
              .then(response => {
                const uniqueQuestions = response.data;
                settotalq(uniqueQuestions);
              })
              .catch(error => {
                console.error("Error fetching question IDs:", error);
              });
          }
        })
        .catch(error => {
          console.error("Error fetching user tests:", error);
        });
    }
  }

  useEffect(() => {
    createtestoptions();
  }, []);

  useEffect(() => {
    let newDiff = { E: [], M: [], H: [] }; // Start with a fresh object
    let seenIds = new Set();  // To track seen question IDs to avoid duplicates


    const addItems = (items) => {
      items.forEach(item => {
        if (!seenIds.has(item.questionIds)) {  // Check if the question ID has already been added
          seenIds.add(item.questionIds);  // Mark this ID as seen
          if (newDiff[item.difficultys]) {  // Ensure the difficulty key exists in the diff object
            newDiff[item.difficultys].push(item);  // Push the item
          }
        }
      });
    };

    if (activeFilters.unused) {
      addItems(totalq);
    }

    if (activeFilters.correct) {
      addItems(correct);
    }

    if (activeFilters.incorrect) {
      addItems(incorrect);
    }

    if (activeFilters.marked) {
      addItems(marked);
    }

    if (activeFilters.omitted) {
      addItems(omitted);
    }

    setDiff(newDiff);  // Update the state with the new diff object
  }, [totalq, correct, incorrect, marked, omitted, activeFilters]);

  const toggleSubject = (index) => {
    // First, determine which subject array to use based on `activeSegment`
    let subjectsArray = activeSegment === 'English' ? esubjects :
      activeSegment === 'Math' ? msubjects : [...esubjects, ...msubjects];

    // Check if the index is within the bounds of the array
    if (index >= 0 && index < subjectsArray.length) {
      const newSubjects = subjectsArray.map((subject, i) => {
        if (i === index) {
          return { ...subject, isOpen: !subject.isOpen }; // Toggle isOpen
        }
        return subject;
      });

      // Update the appropriate state based on `activeSegment`
      if (activeSegment === 'English') {
        esetSubjects(newSubjects);
      } else if (activeSegment === 'Math') {
        msetSubjects(newSubjects);
      } else {
        esetSubjects(newSubjects.slice(0, esubjects.length));
        msetSubjects(newSubjects.slice(esubjects.length));
      }
    } else {
      console.error("Subject index out of bounds");
    }
  };


  const [activeDifficulties, setActiveDifficulties] = useState({
    low: false,
    medium: false,
    high: false
  });

  const toggleDifficulty = (level) => {
    setActiveDifficulties(prev => ({
      ...prev,
      [level]: !prev[level] // Toggle the specific difficulty level
    }));
  };

  const toggleFilter = (filter) => {
    setActiveFilters((prev) => ({
      ...prev,
      [filter]: !prev[filter]
    }));
  };

  useEffect(() => {
    if (user && selectedButton != null && user.role === 'student') {
      localStorage.removeItem('currentTest');
      navigate(`/sat/preset/quiz/${selectedButton}`);
    }
  }, [selectedButton]);

  const random_sat = () => {
    setLoading(true);
    axios.get(`${BASELINE}sat/random`)
      .then(response => {
        if (user) {
          navigate(`/sat/preset/quiz/customrandom`, { state: { data: response.data } });
        }
      })
      .catch(error => {
        console.error(error);
        toast.error('Failed to fetch SAT data!');
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    let combinedQuestions = []; // This will hold the combined questions from selected difficulties
    let seenIds = new Set(); // To track seen question IDs to avoid duplicates
    let engQuestions = []; // To hold English questions
    let mathQuestions = []; // To hold Math questions

    const addItems = (items) => {
      items.forEach(item => {
        if (!seenIds.has(item.questionIds)) { // Check if the question ID has already been added
          seenIds.add(item.questionIds); // Mark this ID as seen
          combinedQuestions.push(item); // Push the item into the combined array
        }
      });
    };

    // Include questions based on active difficulty filters
    if (activeDifficulties.low) {
      addItems(diff.E);
    }
    if (activeDifficulties.medium) {
      addItems(diff.M);
    }
    if (activeDifficulties.high) {
      addItems(diff.H);
    }

    // Split combined questions into 'eng' and 'math'
    combinedQuestions.forEach(question => {
      if (question.tag === 'eng') {
        engQuestions.push(question);
      } else if (question.tag === 'math') {
        mathQuestions.push(question);
      }
    });
    setEnglishCount(engQuestions);
    setMathCount(mathQuestions);
  }, [diff, activeDifficulties]); // Dependency array includes 'diff' and 'activeDifficulties'

  useEffect(() => {
    if (activeSegment === 'English') {
      setDisplaySubjects(esubjects);
    } else if (activeSegment === 'Math') {
      setDisplaySubjects(msubjects);
    } else if (activeSegment === 'All') {
      // Combines English and Math subjects without duplicates
      setDisplaySubjects([...esubjects, ...msubjects]);
    }
  }, [activeSegment, esubjects, msubjects]);

  useEffect(() => {
    // Create a deep copy of esubjects to manipulate
    const updatedSubjects2 = esubjects.map(subject => ({
      ...subject,
      count: 0,  // Reset subject count to 0 initially
      isSelected: false,
      subTopics: subject.subTopics.map(sub => ({
        ...sub,
        count: 0, // Reset subtopic count to 0
        isSelected: false
      }))
    }));

    // Create a deep copy of msubjects to manipulate
    const updatedSubjects = msubjects.map(subject => ({
      ...subject,
      count: 0,  // Reset subject count to 0 initially
      isSelected: false,
      subTopics: subject.subTopics.map(sub => ({
        ...sub,
        count: 0,  // Reset subtopic count to 0
        isSelected: false,
      }))
    }));

    // Iterate over each question and update the corresponding subTopic count
    mathCount.forEach(question => {
      updatedSubjects.forEach(subject => {
        let subjectCount = 0;
        subject.subTopics.forEach(subTopic => {

          if (
            subTopic.name.replace(/\s+/g, "").toLowerCase() ===
            question.topic.replace(/\s+/g, "").toLowerCase()
          ) {
            subTopic.count += 1; // Increment the count if the topics match
            subTopic.isSelected = true; // Update isSelected based on conditions
            subjectCount += 1;
          }
          if (subTopic.count === 0) {
            subTopic.isSelected = false;
          }
        });
        subject.count += subjectCount;
        if (subject.count > 0) {
          subject.isSelected = true; // Set the subject to selected if any subTopics are selected
        }
      });
    });

    // Update the state with the new subjects data
    msetSubjects(updatedSubjects);

    // Iterate over each question and update the corresponding subTopic count
    englishCount.forEach(question => {
      updatedSubjects2.forEach(subject => {
        let subjectCount = 0;
        subject.subTopics.forEach(subTopic => {
          if (
            subTopic.name.replace(/\s+/g, "").toLowerCase() ===
            question.topic.replace(/\s+/g, "").toLowerCase()
          ) {
            subTopic.count += 1; // Increment the count if the topics match
            subTopic.isSelected = true;
            subjectCount += 1;
          }
          if (subTopic.count === 0) {
            subTopic.isSelected = false;
          }
        });
        subject.count += subjectCount;

        if (subject.count > 0) {
          subject.isSelected = true;
        }
      });
    });

    // Update the state with the new subjects data
    esetSubjects(updatedSubjects2);

  }, [englishCount, mathCount, diff]);  // Depend on mathCount to trigger this effect

  useEffect(() => {

    if (activeSegment === 'English') {
      let total = 0;
      let min = 0;
      esubjects.forEach(subject => {
        let alert = 0;
        subject.subTopics.forEach(subTopic => {
          if (subTopic.isSelected === false) {
            alert = 1;
          } else {
            total += subTopic.count;
            min += 1;
          }
        });
        if (alert === 1) {
          subject.isSelected = false;
        } else {
          subject.isSelected = true;
        }
      });
      setmin(min);
      settotal(total);
    }

    if (activeSegment === 'Math') {
      let total = 0;
      let min = 0;
      msubjects.forEach(subject => {
        let alert = 0;
        subject.subTopics.forEach(subTopic => {
          if (!subTopic.isSelected) {
            alert = 1;
          } else {
            total += subTopic.count;
            min += 1;
          }
        });
        if (alert === 1) {
          subject.isSelected = false;
        } else {
          subject.isSelected = true;
        }
      });
      settotal(total);  // Assume you have a separate state for math total
      setmin(min);      // Assume you have a separate state for math minimum
    }

    if (activeSegment === 'All') {
      let total = 0;
      let min = 0;

      msubjects.forEach(subject => {
        let alert = 0;
        subject.subTopics.forEach(subTopic => {
          if (!subTopic.isSelected) {
            alert = 1;
          } else {
            total += subTopic.count;
            min += 1;
          }
        });
        if (alert === 1) {
          subject.isSelected = false;
        } else {
          subject.isSelected = true;
        }
      });

      esubjects.forEach(subject => {
        let alert = 0;
        subject.subTopics.forEach(subTopic => {
          if (subTopic.isSelected === false) {
            alert = 1;
          } else {
            total += subTopic.count;
            min += 1;
          }
        });
        if (alert === 1) {
          subject.isSelected = false;
        } else {
          subject.isSelected = true;
        }
      });

      settotal(total);  // Assume you have a separate state for math total
      setmin(min);      // Assume you have a separate state for math minimum
    }

  }, [activeSegment, msubjects, esubjects])

  function shuffleArray(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  const handleSectionTest = (sectionNum) => {
    const cfg = SAT_SECTION_CONFIG[sectionNum];

    function uniqueByQId(arr) {
      const map = new Map();
      arr.forEach(item => map.set(item.questionIds, item));
      return Array.from(map.values());
    }

    const fullPool = uniqueByQId([
      ...(Array.isArray(correct)   ? correct   : []).filter(q => q.tag === cfg.tag),
      ...(Array.isArray(incorrect) ? incorrect : []).filter(q => q.tag === cfg.tag),
      ...(Array.isArray(marked)    ? marked    : []).filter(q => q.tag === cfg.tag),
      ...(Array.isArray(omitted)   ? omitted   : []).filter(q => q.tag === cfg.tag),
      ...(Array.isArray(totalq)    ? totalq    : []).filter(q => q.tag === cfg.tag),
    ]);

    if (fullPool.length === 0) {
      toast.error(`No ${cfg.uiTag} questions available.`);
      return;
    }

    const selected = [];
    const usedIds = new Set();

    cfg.domains.forEach(({ subtopics, count }) => {
      let domainSelected = 0;
      const dE = Math.round(count * cfg.diffDist.E);
      const dM = Math.round(count * cfg.diffDist.M);
      const dH = count - dE - dM;

      const pickDiff = (diffKey, need) => {
        if (need <= 0 || domainSelected >= count) return;
        const pool = shuffleArray(fullPool.filter(q => subtopics.includes(q.topic) && q.difficultys === diffKey && !usedIds.has(q.questionIds)));
        pool.slice(0, need).forEach(q => {
          if (domainSelected < count) { selected.push(q); usedIds.add(q.questionIds); domainSelected++; }
        });
      };

      pickDiff('E', dE);
      pickDiff('M', dM);
      pickDiff('H', dH);

      // Fill any remainder with any difficulty from this domain
      if (domainSelected < count) {
        const extra = shuffleArray(fullPool.filter(q => subtopics.includes(q.topic) && !usedIds.has(q.questionIds)));
        extra.slice(0, count - domainSelected).forEach(q => { selected.push(q); usedIds.add(q.questionIds); domainSelected++; });
      }
    });

    if (selected.length === 0) {
      toast.error(`Not enough questions available for Section ${sectionNum}.`);
      return;
    }

    clearLocalStorageExceptUser();
    navigate(`/sat/quiz/`, {
      state: {
        data: {
          questionIds: selected.map(q => q.questionIds),
          tag: cfg.uiTag,
          type: 'SAT',
          back: true,
          help: true,
          tutorModeActive: false,
          timedModeActive: true,
          timeLimit: cfg.timeMin,
          blitzModeActive: false,
        },
      },
    });
  };

  const handleGenerateTest = () => {
    // Step 1: Validate the number of passages
    if (currentPassages < min) {
      toast.error("Number of questions is less than the minimum allowed.");
      return;
    }
    if (currentPassages > total) {
      toast.error("Number of questions exceeds the maximum allowed.");
      return;
    }

    // Step 2: Combine English and Math questions based on the active segment
    let combinedQuestions = [];
    if (activeSegment === 'English') {
      combinedQuestions = englishCount;
    } else if (activeSegment === 'Math') {
      combinedQuestions = mathCount;
    } else if (activeSegment === 'All') {
      combinedQuestions = [...englishCount, ...mathCount];
    }

    // Step 3: Apply filters based on difficulty
    const difficultyFilteredQuestions = combinedQuestions.filter(question =>
      (activeDifficulties.low && question.difficultys === 'E') ||
      (activeDifficulties.medium && question.difficultys === 'M') ||
      (activeDifficulties.high && question.difficultys === 'H')
    );

    // Step 4: 모달에서 선택한 subTopic들만 수집
    const topicsSelected = displaySubjects
      .flatMap(subject =>
        subject.subTopics.filter(st => st.isSelected && st.count > 0)
      );

    if (topicsSelected.length === 0) {
      toast.error("No subtopics selected.");
      return;
    }

    // =====================================================
    // =========== [Step 5] subTopic별 '랜덤 분배' 로직 ===========
    // =====================================================
    let questionsToUse = [];
    let needed = currentPassages;

    // 5-1) subTopic을 균등 분배하기 위해, 각 subtopic 별로 뽑을 개수를 먼저 계산
    const totalSubtopics = topicsSelected.length;

    // 예: totalSubtopics=2, currentPassages=5 → baseCount=2, remainder=1 → A=2, B=3
    const baseCount = Math.floor(needed / totalSubtopics);
    let remainder = needed % totalSubtopics;

    // subtopic별 분배 개수 배열
    let subtopicCounts = topicsSelected.map(() => baseCount);

    // 나머지를 앞에서부터 1개씩 분배
    for (let i = 0; i < subtopicCounts.length && remainder > 0; i++) {
      subtopicCounts[i]++;
      remainder--;
    }

    // 5-2) 각 subtopic에 대해, 
    //      subtopicCounts[i] 만큼 그 subtopic의 pool에서 랜덤 추출
    //      subtopic에 남은 문제가 부족하면 있는 만큼만 가져오기
    function getRandomSampleFromArray(arr, count) {
      // Fisher-Yates Shuffle 후 앞에서 count개 잘라오는 helper
      const shuffled = [...arr];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled.slice(0, count);
    }

    // 실제 subtopic 분배
    topicsSelected.forEach((topic, idx) => {
      // 이 subtopic에 해당하는 문제들만 필터
      const questionsForTopic = difficultyFilteredQuestions.filter(
        (q) => q.topic === topic.name
      );

      // 이 subtopic에 대해 할당된 개수
      const subCount = subtopicCounts[idx];

      if (questionsForTopic.length === 0) {
        // 해당 subtopic pool이 없으면 건너뜀
        return;
      }

      if (questionsForTopic.length <= subCount) {
        // subtopic이 가진 문제보다 할당량이 많으면 → 전부 다
        // (array of question objects)
        questionsForTopic.forEach((q) => {
          if (!questionsToUse.includes(q.questionIds)) {
            questionsToUse.push(q.questionIds);
          }
        });
      } else {
        // subtopic 문제 pool 중 무작위 subCount개
        const sample = getRandomSampleFromArray(questionsForTopic, subCount);
        sample.forEach((q) => {
          if (!questionsToUse.includes(q.questionIds)) {
            questionsToUse.push(q.questionIds);
          }
        });
      }
    });

    // 5-3) 위 과정으로 아직 needed 못 채웠으면 => 전체 pool(difficultyFilteredQuestions)에서 랜덤 추가
    //      (예: subtopic a,b 둘 다 부족해서 목표 5개 못 만든 경우)
    while (questionsToUse.length < currentPassages) {
      // 선택된 subTopic에 해당하는 문제들만 다시 추출
      const subtopicQuestions = topicsSelected.flatMap(topic =>
        difficultyFilteredQuestions.filter(q => q.topic === topic.name)
      );

      // 이미 questionsToUse에 들어간 문제는 제외
      const remainingPool = subtopicQuestions.filter(q => !questionsToUse.includes(q.questionIds));

      // 더 이상 뽑을 수 있는 문제가 없으면 break
      if (remainingPool.length === 0) {
        // 필요하다면 토스트 에러나 안내 문구 처리 가능
        // toast.error("Not enough questions in the selected subtopics to meet your requested count.");
        break;
      }

      // remainingPool 중 랜덤 1문제를 추가
      const randomIndex = Math.floor(Math.random() * remainingPool.length);
      const additionalQuestion = remainingPool[randomIndex];

      questionsToUse.push(additionalQuestion.questionIds);
    }
    // =====================================================
    // 위 로직으로 questionsToUse에는 currentPassages(혹은 가능한 만큼)의 문제 ID가 들어감
    // =====================================================

    // Step 6: Prepare data for navigation
    let back = false;
    let help = false;
    if (user.role === 'teacher') {
      back = true;
      help = true;
    }

    const quizData = {
      questionIds: questionsToUse,
      tutorModeActive: isTutorActive,
      timedModeActive: isTimedActive,
      timeLimit: isTimedActive ? timerMinutes : null,
      blitzModeActive: isBlitzActive,
      blitzTimeLimit: isBlitzActive ? Number(blitzSeconds) : null,
      tag: activeSegment,
      back: back,
      help: help,
      type: "SAT",
    };

    // Clear localStorage to avoid conflicts
    clearLocalStorageExceptUser();

    // Finally, navigate
    navigate(`/sat/quiz/`, { state: { data: quizData } });
  };

  const handleMCQClick = () => {
    const countNeeded = 15;
    const selectedMCQ = getQuestionsWithPriority('eng', countNeeded);

    if (selectedMCQ.length < countNeeded) {
      toast.error("Not enough MCQ questions available to meet the requirement of 15 questions.");
      return;
    }

    const questionIds = selectedMCQ.map(q => q.item ? q.item.questionIds : q.questionIds);

    const quizData = {
      questionIds,
      tutorModeActive: isTutorActive,
      timedModeActive: isTimedActive,
      timeLimit: isTimedActive ? timerMinutes : null,
      blitzModeActive: isBlitzActive,
      blitzTimeLimit: isBlitzActive ? Number(blitzSeconds) : null,
      tag: "English",
      type: "SAT",
    };
    clearLocalStorageExceptUser();

    navigate(`/sat/quiz/`, { state: { data: quizData } });
  };

  const handleFRQClick = () => {
    const countNeeded = 15;
    const selectedFRQ = getQuestionsWithPriority('math', countNeeded);

    if (selectedFRQ.length < countNeeded) {
      toast.error("Not enough FRQ questions available to meet the requirement of 15 questions.");
      return;
    }

    const questionIds = selectedFRQ.map(q => q.item ? q.item.questionIds : q.questionIds);

    clearLocalStorageExceptUser();
    const quizData = {
      questionIds,
      tutorModeActive: isTutorActive,
      timedModeActive: isTimedActive,
      timeLimit: isTimedActive ? timerMinutes : null,
      blitzModeActive: isBlitzActive,
      blitzTimeLimit: isBlitzActive ? Number(blitzSeconds) : null,
      tag: "Math",
      type: "SAT",
    };
    navigate(`/sat/quiz/`, { state: { data: quizData } });
  };

  function getRandomFromArray(arr, count) {
    // arr를 복사한 뒤 Fisher-Yates shuffle
    const shuffled = [...arr];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled.slice(0, count);
  }

  function getQuestionsWithPriority(tag, countNeeded) {
    // section: 'mcq' or 'frq'
    // incorrect, correct, totalq(unused)에서 해당 section만 필터링
    const incorrectQuestions = (incorrect || []).filter(q => q.tag === tag);
    const unusedQuestions = (totalq || []).filter(q => q.tag === tag);
    const correctQuestions = (correct || []).filter(q => q.tag === tag);

    let selected = [];
    // 1차: incorrect에서 최대 countNeeded까지
    const fromIncorrect = getRandomFromArray(incorrectQuestions, Math.min(countNeeded, incorrectQuestions.length));
    selected = [...selected, ...fromIncorrect];
    let remaining = countNeeded - selected.length;

    if (remaining > 0) {
      // 2차: unused에서 추가
      const fromUnused = getRandomFromArray(unusedQuestions, Math.min(remaining, unusedQuestions.length));
      selected = [...selected, ...fromUnused];
      remaining = countNeeded - selected.length;
    }

    if (remaining > 0) {
      // 3차: correct에서 추가
      const fromCorrect = getRandomFromArray(correctQuestions, Math.min(remaining, correctQuestions.length));
      selected = [...selected, ...fromCorrect];
      remaining = countNeeded - selected.length;
    }
    return selected;
  }

  const handleCardClick = (num) => {
    setPendingMockSat(num);
    setShowConfirmModal(true);
  };

  const handleConfirm = () => {
    setSelectedButton(pendingMockSat);
    setShowConfirmModal(false);
    // 필요한 경우 추가 작업 수행 후 navigate 등 호출
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
    setPendingMockSat(null);
  };


  const handleRandomGenClick = (id) => {

    // helper: Fisher-Yates Shuffle로 배열 랜덤화 후, 앞에서 count개를 잘라내는 함수
    function getRandomFromArray(arr, count) {
      const shuffled = [...arr];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled.slice(0, count);
    }

    // helper: 중복 제거 (questionIds가 같은 문제는 하나만)
    function uniqueByQuestionId(arr) {
      const map = new Map();
      arr.forEach(item => {
        map.set(item.questionIds, item);
      });
      return Array.from(map.values());
    }

    // (1) id가 "randomeng" → 영어(E/M/H) 문제 중 랜덤 27개
    if (id === 'randomeng') {
      // 1. 모든 영어 문제를 합침 (correct, incorrect, marked, omitted, totalq)
      let allEnglish = [
        ...correct.filter(q => q.tag === 'eng'),
        ...incorrect.filter(q => q.tag === 'eng'),
        ...marked.filter(q => q.tag === 'eng'),
        ...omitted.filter(q => q.tag === 'eng'),
        ...totalq.filter(q => q.tag === 'eng'),
      ];

      // 2. 중복 제거
      allEnglish = uniqueByQuestionId(allEnglish);

      // 3. 난이도 E/M/H 전부 포함 → 즉 별도 필터 없이 allEnglish 그대로 사용
      //    (만약 E/M/H 중 어떤 것도 허용한다면 필터할 필요 없음)

      // 4. 만약 보유 문제보다 27개가 많으면 => 가능한 만큼만 사용
      const limit = Math.min(27, allEnglish.length);

      // 5. Fisher-Yates Shuffle 후 limit개 뽑기
      const selectedQuestions = getRandomFromArray(allEnglish, limit);

      // 6. quizData 구성
      let back = false;
      let help = false;
      if (user && user.role === 'teacher') {
        back = true;
        help = true;
      }

      const quizData = {
        questionIds: selectedQuestions.map(q => q.questionIds),
        tutorModeActive: isTutorActive,
        timedModeActive: isTimedActive,
        timeLimit: isTimedActive ? timerMinutes : null,
        blitzModeActive: isBlitzActive,
        blitzTimeLimit: isBlitzActive ? Number(blitzSeconds) : null,
        tag: "English",
        back: back,
        help: help,
        type: "SAT",
      };

      // localStorage 정리 후 이동
      clearLocalStorageExceptUser();
      navigate(`/sat/quiz/`, { state: { data: quizData } });
      return; // 여기서 종료
    }

    // (2) id가 "randommath" → 수학(E/M/H) 문제 중 랜덤 22개
    if (id === 'randommath') {
      // 1. 모든 Math 문제를 합침
      let allMath = [
        ...correct.filter(q => q.tag === 'math'),
        ...incorrect.filter(q => q.tag === 'math'),
        ...marked.filter(q => q.tag === 'math'),
        ...omitted.filter(q => q.tag === 'math'),
        ...totalq.filter(q => q.tag === 'math'),
      ];

      // 2. 중복 제거
      allMath = uniqueByQuestionId(allMath);

      // 3. 난이도 E/M/H 전부 포함
      //    (필요하다면 추가 필터 가능하지만, "모두 섞어서" 라고 했으므로 그대로 사용)

      // 4. 22개만큼 뽑기 (보유 문제 < 22일 경우 가능한 만큼만)
      const limit = Math.min(22, allMath.length);

      const selectedQuestions = getRandomFromArray(allMath, limit);

      let back = false;
      let help = false;
      if (user && user.role === 'teacher') {
        back = true;
        help = true;
      }

      const quizData = {
        questionIds: selectedQuestions.map(q => q.questionIds),
        tutorModeActive: isTutorActive,
        timedModeActive: isTimedActive,
        timeLimit: isTimedActive ? timerMinutes : null,
        blitzModeActive: isBlitzActive,
        blitzTimeLimit: isBlitzActive ? Number(blitzSeconds) : null,
        tag: "Math",
        back: back,
        help: help,
        type: "SAT",
      };

      clearLocalStorageExceptUser();
      navigate(`/sat/quiz/`, { state: { data: quizData } });
      return;
    }

    if (id === 'randomsat') {
      random_sat();
      return;
    }
  };

  const isTeacher = user?.role === 'teacher';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="pb-8"
    >
      {/* Mock Digital SAT — student only */}
      {!isTeacher && (
        <div className="mt-6 sm:mt-8 mx-4 sm:mx-[280px]">
          {/* Light-tone container */}
          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-6 pt-5 pb-4 border-b border-slate-100">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-sm shadow-blue-200">
                  <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-lg font-bold text-slate-800 leading-tight">Mock Digital SAT</h1>
                  <p className="text-[11px] text-slate-400 font-medium">Full-length practice tests</p>
                </div>
              </div>
              <span className="text-[10px] font-bold text-blue-600 bg-blue-50 border border-blue-100 px-2.5 py-1 rounded-full uppercase tracking-wide">
                {allSATScores.length > 0
                  ? `${Math.min(mockCardData.filter(n => getMockScoresForCard(n)).length, 6)} / 6 Done`
                  : '6 Tests'}
              </span>
            </div>

            {/* Cards */}
            <div className="bg-slate-50/40 px-4 py-4">
              <MockSATSection
                mockCardData={mockCardData}
                handleCardClick={handleCardClick}
                getMockScoresForCard={getMockScoresForCard}
                showConfirmModal={showConfirmModal}
                handleConfirm={handleConfirm}
                handleCancel={handleCancel}
              />
            </div>
          </div>
        </div>
      )}


      {/* Personalize SAT Test */}
      <div className={`mx-4 md:mx-[280px] ${isTeacher ? '' : 'mt-4'} pb-8`}>
        {/* Section header */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-sm shadow-blue-200 flex-shrink-0">
            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
            </svg>
          </div>
          <div>
            <h1 className="text-lg font-bold text-slate-800 leading-tight">Personalize SAT Test</h1>
            <p className="text-[11px] text-slate-400 font-medium">Build a custom test from your question pool</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">

          {/* Test Mode */}
          <div className="p-5 border-b border-slate-100">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-0.5 h-3.5 bg-gradient-to-b from-blue-500 to-indigo-500 rounded-full" />
              <span className="text-slate-700 text-sm font-semibold">Test Mode</span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {/* AI Support */}
              <div className={`border rounded-xl p-3.5 transition-all duration-200 ${
                isBlitzActive
                  ? 'bg-slate-50 border-slate-200 opacity-40 pointer-events-none'
                  : isTutorActive
                  ? 'bg-blue-50 border-blue-300 cursor-pointer shadow-sm shadow-blue-100'
                  : 'bg-white border-slate-200 hover:bg-slate-50 hover:border-slate-300 cursor-pointer'
              }`}
                onClick={() => { if (!isBlitzActive) setIsTutorActive(!isTutorActive); }}>
                <div className="flex items-center justify-between mb-1">
                  <span className={`text-sm font-semibold ${isTutorActive && !isBlitzActive ? 'text-blue-600' : 'text-slate-600'}`}>AI Support</span>
                  <div className={`w-9 flex items-center rounded-full px-0.5 transition-all duration-300 ${isTutorActive && !isBlitzActive ? 'bg-blue-500 justify-end' : 'bg-slate-200 justify-start'}`}
                    style={{ minWidth: '36px', height: '18px' }}>
                    <div className="bg-white w-3.5 h-3.5 rounded-full shadow-sm" />
                  </div>
                </div>
                <p className="text-[11px] text-slate-400 leading-snug">Discuss each problem with AI after answering.</p>
              </div>

              {/* Timed */}
              <div className={`border rounded-xl p-3.5 transition-all duration-200 ${
                isBlitzActive
                  ? 'bg-slate-50 border-slate-200 opacity-40 pointer-events-none'
                  : isTimedActive
                  ? 'bg-blue-50 border-blue-300 cursor-pointer shadow-sm shadow-blue-100'
                  : 'bg-white border-slate-200 hover:bg-slate-50 hover:border-slate-300 cursor-pointer'
              }`}
                onClick={() => { if (!isBlitzActive) setIsTimedActive(!isTimedActive); }}>
                <div className="flex items-center justify-between mb-1">
                  <span className={`text-sm font-semibold ${isTimedActive && !isBlitzActive ? 'text-blue-600' : 'text-slate-600'}`}>Timed</span>
                  <div className={`w-9 flex items-center rounded-full px-0.5 transition-all duration-300 ${isTimedActive && !isBlitzActive ? 'bg-blue-500 justify-end' : 'bg-slate-200 justify-start'}`}
                    style={{ minWidth: '36px', height: '18px' }}>
                    <div className="bg-white w-3.5 h-3.5 rounded-full shadow-sm" />
                  </div>
                </div>
                <p className="text-[11px] text-slate-400 leading-snug">Set a total time limit for the quiz.</p>
                {isTimedActive && !isBlitzActive && (
                  <div className="flex items-center gap-2 mt-2" onClick={e => e.stopPropagation()}>
                    <input
                      type="number"
                      value={timerMinutes}
                      onChange={(e) => setTimerMinutes(e.target.value)}
                      className="w-16 pl-2 pr-1 rounded-lg text-sm text-slate-700 bg-white border border-slate-300 focus:ring-1 focus:ring-blue-400 focus:outline-none"
                      min="1"
                    />
                    <span className="text-slate-500 text-xs font-medium">min</span>
                  </div>
                )}
              </div>

              {/* Blitz Mode */}
              <div className={`border rounded-xl p-3.5 transition-all duration-200 ${
                isBlitzActive
                  ? 'bg-orange-50 border-orange-300 cursor-pointer shadow-sm shadow-orange-100'
                  : 'bg-white border-slate-200 hover:bg-slate-50 hover:border-slate-300 cursor-pointer'
              }`}
                onClick={() => {
                  if (!isBlitzActive) {
                    setIsTimedActive(false);
                    setIsTutorActive(false);
                    toast('Blitz Mode: No auto-save and AI support disabled.', { duration: 5000 });
                  }
                  setIsBlitzActive(!isBlitzActive);
                }}>
                <div className="flex items-center justify-between mb-1">
                  <span className={`text-sm font-semibold ${isBlitzActive ? 'text-orange-600' : 'text-slate-600'}`}>Blitz Mode</span>
                  <div className={`w-9 flex items-center rounded-full px-0.5 transition-all duration-300 ${isBlitzActive ? 'bg-orange-500 justify-end' : 'bg-slate-200 justify-start'}`}
                    style={{ minWidth: '36px', height: '18px' }}>
                    <div className="bg-white w-3.5 h-3.5 rounded-full shadow-sm" />
                  </div>
                </div>
                <p className="text-[11px] text-slate-400 leading-snug">Per-question timer. Auto-advances. No save or AI.</p>
                {isBlitzActive && (
                  <div className="flex items-center gap-2 mt-2" onClick={e => e.stopPropagation()}>
                    <input
                      type="number"
                      value={blitzSeconds}
                      onChange={(e) => setBlitzSeconds(Math.max(5, Number(e.target.value)))}
                      className="w-16 pl-2 pr-1 rounded-lg text-sm text-orange-700 bg-white border border-orange-300 focus:ring-1 focus:ring-orange-400 focus:outline-none"
                      min="5"
                    />
                    <span className="text-orange-500 text-xs font-medium">sec / q</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="p-5 space-y-4">

            {/* SAT Section Practice */}
            {!isTutorActive && !isTimedActive && !isBlitzActive && (
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-0.5 h-3.5 bg-gradient-to-b from-blue-500 to-indigo-500 rounded-full" />
                  <span className="text-slate-700 text-sm font-semibold">SAT Section Practice</span>
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide bg-indigo-50 border border-indigo-200 text-indigo-600">
                    Teacher
                  </span>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
                  {[
                    { num: 1, label: 'Section 1', sub: 'R&W · Module 1', q: '27q', time: '32 min', isEng: true },
                    { num: 2, label: 'Section 2', sub: 'R&W · Module 2', q: '27q', time: '32 min', isEng: true },
                    { num: 3, label: 'Section 3', sub: 'Math · Module 1', q: '22q', time: '35 min', isEng: false },
                    { num: 4, label: 'Section 4', sub: 'Math · Module 2', q: '22q', time: '35 min', isEng: false },
                  ].map(({ num, label, sub, q, time, isEng }) => (
                    <div
                      key={num}
                      onClick={() => handleSectionTest(num)}
                      className={`border rounded-xl p-3.5 cursor-pointer transition-all duration-200 ${
                        isEng
                          ? 'bg-white border-slate-200 hover:bg-blue-50 hover:border-blue-300'
                          : 'bg-white border-slate-200 hover:bg-emerald-50 hover:border-emerald-300'
                      }`}>
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-sm font-semibold text-slate-700">{label}</span>
                      </div>
                      <p className="text-[11px] text-slate-400 leading-snug">{sub}</p>
                      <div className="flex items-center gap-1.5 mt-2">
                        <span className="text-[10px] text-slate-400">{q}</span>
                        <span className="text-[10px] text-slate-300">·</span>
                        <span className="text-[10px] text-slate-400">{time}</span>
                      </div>
                    </div>
                  ))}

                  {/* Random Full SAT */}
                  <div
                    onClick={() => handleRandomGenClick('randomsat')}
                    className="border-2 border-dashed border-violet-300 bg-violet-50 hover:bg-violet-100 hover:border-violet-400 rounded-xl p-3.5 cursor-pointer transition-all duration-200 flex flex-col justify-between"
                  >
                    <div>
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-sm font-semibold text-violet-700">Full SAT</span>
                        <span className="text-[9px] font-bold text-violet-500 bg-violet-100 border border-violet-200 px-1.5 py-0.5 rounded-full uppercase tracking-wide">Random</span>
                      </div>
                      <p className="text-[11px] text-violet-500 leading-snug">All 4 sections · Random questions</p>
                    </div>
                    <div className="flex items-center gap-1.5 mt-2">
                      <span className="text-[10px] text-violet-400">49q</span>
                      <span className="text-[10px] text-violet-300">·</span>
                      <span className="text-[10px] text-violet-400">~2 hr 15 min</span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Filters: Question Pool + Difficulty */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <SectionCard label="Question Pool">
                <div className="flex flex-wrap gap-2">
                  <FilterButton label="Unused" count={totalq.length} isActive={activeFilters.unused} toggleFilter={() => toggleFilter('unused')} />
                  {user && user.role === 'student' && (
                    <>
                      <FilterButton label="Correct" count={correct.length} isActive={activeFilters.correct} toggleFilter={() => toggleFilter('correct')} />
                      <FilterButton label="Incorrect" count={incorrect.length} isActive={activeFilters.incorrect} toggleFilter={() => toggleFilter('incorrect')} />
                      <FilterButton label="Marked" count={marked.length} isActive={activeFilters.marked} toggleFilter={() => toggleFilter('marked')} />
                      <FilterButton label="Omitted" count={omitted.length} isActive={activeFilters.omitted} toggleFilter={() => toggleFilter('omitted')} />
                    </>
                  )}
                  {user && user.role === 'teacher' && (
                    <FilterButton label="Used" count={omitted.length} isActive={activeFilters.omitted} toggleFilter={() => toggleFilter('omitted')} />
                  )}
                </div>
              </SectionCard>
              <SectionCard label="Difficulty">
                <div className="flex flex-wrap gap-2">
                  <FilterButton label="Easy" count={diff.E.length} isActive={activeDifficulties.low} toggleFilter={() => toggleDifficulty('low')} />
                  <FilterButton label="Medium" count={diff.M.length} isActive={activeDifficulties.medium} toggleFilter={() => toggleDifficulty('medium')} />
                  <FilterButton label="Hard" count={diff.H.length} isActive={activeDifficulties.high} toggleFilter={() => toggleDifficulty('high')} />
                </div>
              </SectionCard>
            </div>

            {/* Subjects */}
            <div className="bg-slate-50 border border-slate-200 rounded-2xl p-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <div className="w-0.5 h-3.5 bg-gradient-to-b from-blue-500 to-indigo-500 rounded-full" />
                  <span className="text-slate-700 text-sm font-semibold">Subjects</span>
                </div>
                <div className="flex rounded-lg overflow-hidden mt-2 sm:mt-0 border border-slate-200 bg-white">
                  {['English', 'Math'].map(segment => {
                    const count = segment === 'English' ? englishCount.length : mathCount.length;
                    return (
                      <button
                        key={segment}
                        onClick={() => setActiveSegment(segment)}
                        className={`py-1.5 px-5 text-xs font-semibold transition-all duration-200 ${
                          activeSegment === segment
                            ? 'bg-blue-600 text-white'
                            : 'bg-white text-slate-500 hover:text-slate-700 hover:bg-slate-50'
                        }`}
                      >
                        {segment}
                        <span className={`ml-1.5 ${activeSegment === segment ? 'text-blue-200' : 'text-slate-400'}`}>({count})</span>
                      </button>
                    );
                  })}
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                {displaySubjects.map((subject, index) => (
                  <Subject
                    user={user}
                    index={index}
                    key={`${subject.name}-${subject.tag}`}
                    name={subject.name}
                    count={subject.count}
                    isOpen={subject.isOpen}
                    isSelected={subject.isSelected}
                    toggleOpen={() => toggleSubjectOpen(index)}
                    toggleSelect={() => toggleSubjectSelect(index)}
                    subTopics={subject.subTopics.map((subTopic, subIndex) => ({
                      ...subTopic,
                      toggle: () => toggleSubTopic(subject.tag, index, subIndex),
                    }))}
                  />
                ))}
              </div>
            </div>

            {/* No. of Questions + Generate */}
            <div className="bg-slate-50 border border-slate-200 rounded-2xl p-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-0.5 h-3.5 bg-gradient-to-b from-blue-500 to-indigo-500 rounded-full" />
                    <span className="text-slate-700 text-sm font-semibold">No. of Questions</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <input
                      type="number"
                      value={currentPassages}
                      onChange={(e) => setCurrentPassages(e.target.value)}
                      className="w-20 bg-white border border-slate-300 rounded-lg text-center py-2 text-slate-800 text-sm focus:ring-1 focus:ring-blue-400 focus:outline-none transition-all shadow-sm"
                      min={min}
                    />
                    <div className="flex items-center gap-1.5 text-xs text-slate-400">
                      <span>min {min}</span>
                      <span>/</span>
                      <button
                        onClick={() => setCurrentPassages(total)}
                        className="text-blue-500 hover:text-blue-600 font-semibold transition-colors"
                      >
                        max {total}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="w-full sm:w-56">
                  <GenerateButton onClick={handleGenerateTest} />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </motion.div>
  );
};

const SectionCard = ({ label, children }) => (
  <div className="bg-slate-50 border border-slate-200 rounded-2xl p-4">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-0.5 h-3.5 bg-gradient-to-b from-blue-500 to-indigo-500 rounded-full" />
      <span className="text-slate-700 text-sm font-semibold">{label}</span>
    </div>
    {children}
  </div>
);

const GenerateButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="relative overflow-hidden w-full group bg-gradient-to-r from-blue-600/80 to-indigo-600/80 hover:from-blue-500 hover:to-indigo-500 text-white font-bold py-3 px-6 rounded-xl inline-flex items-center justify-center gap-3 shadow-lg shadow-blue-500/20 hover:shadow-blue-500/40 transition-all duration-300 hover:scale-[1.02] border border-blue-400/30"
  >
    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent pointer-events-none" />
    <span className="text-sm font-bold tracking-widest uppercase">Generate Test</span>
    <AiOutlineInfoCircle className="text-base opacity-70" />
  </button>
);

const SubTopic = ({ name, count, isSelected, toggle }) => (
  <div className="flex justify-between items-center px-2 py-1.5 rounded-lg hover:bg-blue-50 transition-colors duration-150 cursor-pointer" onClick={toggle}>
    <div className="flex items-center gap-2">
      <div className={`w-3.5 h-3.5 rounded flex items-center justify-center border transition-all duration-200 ${isSelected ? 'bg-blue-500 border-blue-500' : 'border-slate-300 bg-white'}`}>
        {isSelected && <AiOutlineCheck className="text-white text-[9px]" />}
      </div>
      <span className={`text-xs leading-tight transition-colors ${isSelected ? 'text-slate-800' : 'text-slate-400'}`}>{name}</span>
    </div>
    <span className={`text-[10px] font-semibold tabular-nums ${isSelected ? 'text-blue-500' : 'text-slate-300'}`}>{count}</span>
  </div>
);

const Subject = ({ name, count, isOpen, isSelected, toggleOpen, toggleSelect, subTopics, user, index }) => (
  <div className="bg-white border border-slate-200 rounded-2xl h-[235px] flex flex-col shadow-sm hover:shadow-md hover:border-blue-200 transition-all duration-200">
    <div className="flex justify-between items-center px-3 pt-3 pb-2 shrink-0">
      <div className="flex items-center gap-2">
        <button onClick={toggleOpen} className="text-slate-400 hover:text-slate-700 transition-colors focus:outline-none">
          {isOpen ? <AiOutlineMinus className="text-xs" /> : <AiOutlinePlus className="text-xs" />}
        </button>
        <div
          onClick={toggleSelect}
          className={`w-4 h-4 rounded-md flex items-center justify-center border cursor-pointer transition-all duration-200 ${isSelected ? 'bg-blue-500 border-blue-500' : 'border-slate-300 bg-white'}`}
        >
          {isSelected && <AiOutlineCheck className="text-white text-[9px]" />}
        </div>
        <span onClick={toggleOpen} className="text-xs font-semibold text-slate-700 cursor-pointer hover:text-blue-600 transition-colors leading-tight">{name}</span>
      </div>
      <span className={`text-xs font-bold tabular-nums ${count > 0 ? 'text-blue-500' : 'text-slate-300'}`}>{count}</span>
    </div>
    <div className="mx-3 h-px bg-slate-100 shrink-0" />
    {isOpen && (
      <div className="flex-1 overflow-y-auto px-1 py-1.5 scrollbar-thin scrollbar-thumb-slate-200 scrollbar-track-transparent">
        {subTopics.map((subTopic, subIndex) => (
          <SubTopic
            key={`${subTopic.name}-${subIndex}`}
            name={subTopic.name}
            count={subTopic.count}
            isSelected={subTopic.isSelected}
            toggle={() => subTopic.toggle(subIndex)}
          />
        ))}
      </div>
    )}
  </div>
);

const ToggleSwitch = ({ label, isEnabled, toggleSwitch, desc }) => (
  <div className="flex items-center gap-1">
    <span className="text-white/80 text-sm font-medium">{label}</span>
    <InfoIconWithTooltip tooltipText={desc} />
    <div
      onClick={toggleSwitch}
      className={`ml-1.5 w-10 h-5 flex items-center rounded-full px-0.5 cursor-pointer transition-all duration-300 ${isEnabled ? 'bg-blue-500/80 justify-end' : 'bg-white/15 justify-start'}`}
    >
      <div className="bg-white w-4 h-4 rounded-full shadow-sm transition-all duration-300" />
    </div>
  </div>
);

const FilterButton = ({ label, count, isActive, toggleFilter }) => (
  <button
    disabled={count === 0}
    onClick={count > 0 ? toggleFilter : undefined}
    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200 border ${
      isActive
        ? 'bg-blue-50 border-blue-300 text-blue-600 shadow-sm shadow-blue-100'
        : 'bg-white border-slate-200 text-slate-500 hover:text-slate-700 hover:border-slate-300 hover:bg-slate-50'
    } ${count === 0 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
  >
    {isActive && <AiOutlineCheck className="text-[10px]" />}
    <span>{label}</span>
    <span className={`tabular-nums ${isActive ? 'text-blue-400' : 'text-slate-400'}`}>{count}</span>
  </button>
);


export default RandomSATReady;
